import React from 'react';
import { GroupedEmployees } from '../../components/common/GroupedEmployees';

export function AllEmployees() {
  return <GroupedEmployees pageTitle="All Employees" />;
}

export default AllEmployees;
